import { defineStyleConfig } from "@chakra-ui/react";

export default defineStyleConfig({
  baseStyle: {
    borderColor: "border.base",
    opacity: 1,
  },
});
